import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import HomePage from './pages/HomePage';
import RenderPage from './pages/RenderPage';
import AdminPage from './pages/AdminPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import DisclaimerPopup from './components/DisclaimerPopup';
import './styles/global.css';

function App() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    // Check if the disclaimer has been shown before
    const hasSeenDisclaimer = localStorage.getItem('hasSeenDisclaimer');
    if (!hasSeenDisclaimer) {
      setShowDisclaimer(true);
    }
    
    // Check if user is authenticated from localStorage
    const authStatus = localStorage.getItem('isAdminAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleDisclaimerClose = () => {
    setShowDisclaimer(false);
    localStorage.setItem('hasSeenDisclaimer', 'true');
  };
  
  const handleLogin = (password) => {
    if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      localStorage.setItem('isAdminAuthenticated', 'true');
      return true;
    }
    return false;
  };
  
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAdminAuthenticated');
  };

  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          {showDisclaimer && <DisclaimerPopup onClose={handleDisclaimerClose} />}
          <div className={`app-content ${showDisclaimer ? 'blurred' : ''}`}>
            <Navbar isAuthenticated={isAuthenticated} onLogout={handleLogout} />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/render/:id" element={<RenderPage />} />
                <Route 
                  path="/admin" 
                  element={isAuthenticated ? <AdminPage /> : <Navigate to="/admin-login" />}
                />
                <Route path="/admin-login" element={
                  <div className="admin-login">
                    <h2>Admin Access</h2>
                    <form onSubmit={(e) => {
                      e.preventDefault();
                      const password = e.target.password.value;
                      if (handleLogin(password)) {
                        window.location.href = '/admin';
                      } else {
                        alert('Invalid password. Please try again.');
                      }
                    }}>
                      <input 
                        type="password"
                        name="password" 
                        placeholder="Master Password" 
                        required
                      />
                      <button type="submit" className="login-button">
                        Login
                      </button>
                    </form>
                  </div>
                } />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;